import { __rest, __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ErrorIcon from '@mui/icons-material/Error';
import React__default, { useState, useEffect } from 'react';
import QRCode from 'react-qr-code';
import { TABLET_SCREEN_SIZE, MOBILE_SCREEN_SIZE } from '../../../utils/constants/Constants.js';
import _get from 'lodash/get';
import brandclub_colors from '../../../colors/brandclubColors.js';
import { Typography } from '@mui/material';
import { ButtonLoadingEllipsis } from '../Loading/index.js';
import '../../../icons/abstract/AbstractArcIcon.js';
import '../../../icons/AddCircleIcon.js';
import '../../../icons/AddCircleOutlineIcon.js';
import '../../../icons/ArrowCircleRightIcon.js';
import '../../../icons/ArrowLeftIcon.js';
import '../../../icons/ArrowRightIcon.js';
import '../../../icons/BoltIcon.js';
import '../../../icons/BookmarkStarIcon.js';
import '../../../icons/CalendarIcon.js';
import '../../../icons/CancelIcon.js';
import '../../../icons/CheckCircleIcon.js';
import '../../../icons/CheckMarkIcon.js';
import '../../../icons/ChevronDownIcon.js';
import '../../../icons/ChevronLeftIcon.js';
import '../../../icons/ChevronRightIcon.js';
import '../../../icons/ChevronUpIcon.js';
import '../../../icons/CloseIcon.js';
import '../../../icons/CopyIcon.js';
import '../../../icons/MenuIcon.js';
import '../../../icons/NotificationActiveIcon.js';
import '../../../icons/PaperPlaneIcon.js';
import '../../../icons/PendingIcon.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PlayCircleIcon.js';
import '../../../icons/RemoveCircleIcon.js';
import '../../../icons/SearchIcon.js';
import '../../../icons/SellIcon.js';
import '../../../icons/ShareIcon.js';
import '../../../icons/ShoppingBagIcon.js';
import '../../../icons/SmartphoneIcon.js';
import '../../../icons/StarIcon.js';
import '../../../icons/StarOutlineIcon.js';
import '../../../icons/SuccessCheckCircleIcon.js';
import '../../../icons/ThumbsDownIcon.js';
import '../../../icons/ThumbsUpIcon.js';
import '../../../icons/TuneIcon.js';
import '../../../icons/FourPointStarIcon.js';
import { Button } from '../../../Components/Button/Button.js';
import '../../../Components/Button/CustomDtcBagButton.js';
import '../../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../../types/filters.js';
import '../../../utils/assetUtils.js';
import '../../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import '../../../utils/stringUtils.js';
import '../../../utils/broadcast.js';
import { formatPhoneNumber } from '../../../utils/formatPhoneNumber.js';
import 'lodash/isEqual';
import 'lodash/orderBy';
import '@splitsoftware/splitio-react';
import '@tanstack/react-query';
import '../../../Auth/index.js';
import '../../../types/Campaign.js';
import '../../../types/product.js';
import '../../../api/graphQl/brand.js';
import '../../../api/graphQl/product.js';
import '../../../api/cache/appConfigQueryOptions.js';
import '@brandclub/types';
import 'lodash/omitBy';
import 'lodash/isNil';
import '../../../utils/logger.js';

const QRCodeContainer = styled(Grid)({
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        display: 'none',
    },
});
var BCPhoneInputVariant;
(function (BCPhoneInputVariant) {
    BCPhoneInputVariant["DEFAULT"] = "default";
    BCPhoneInputVariant["XS"] = "xs";
    BCPhoneInputVariant["SM"] = "sm";
    BCPhoneInputVariant["DRAWER"] = "drawer";
    BCPhoneInputVariant["DRAWER_MOBILE"] = "drawer-mobile";
})(BCPhoneInputVariant || (BCPhoneInputVariant = {}));
const variantStyles = {
    [BCPhoneInputVariant.DEFAULT]: {
        container: {
            maxWidth: '100%',
        },
        inputContainer: {
            height: 56,
            minWidth: 345,
            borderWidth: 1.5,
        },
        input: {
            fontSize: 20,
            margin: '0 0 0 10px',
        },
        prefix: {
            fontSize: 18,
            marginLeft: 20,
        },
        button: {
            fontSize: 18,
            width: 134,
            height: 46,
        },
    },
    [BCPhoneInputVariant.XS]: {
        container: {
            maxWidth: 269,
        },
        inputContainer: {
            height: 39.1,
            minWidth: 269,
            borderWidth: 1,
        },
        input: {
            fontSize: 14,
            margin: '0 0 0 7px',
        },
        prefix: {
            fontSize: 14,
            marginLeft: 7,
        },
        button: {
            fontSize: 14,
            width: 91,
            height: 29,
        },
    },
    [BCPhoneInputVariant.SM]: {
        container: {
            maxWidth: 314,
        },
        inputContainer: {
            height: 46.4,
            minWidth: 314,
            borderWidth: 1.5,
        },
        input: {
            fontSize: 14,
            margin: '0 0 0 7px',
        },
        prefix: {
            fontSize: 14,
            marginLeft: 7,
        },
        button: {
            fontSize: 14,
            width: 106,
            height: 35,
        },
    },
    [BCPhoneInputVariant.DRAWER]: {
        container: {
            maxWidth: 345,
        },
        inputContainer: {
            height: 55,
            minWidth: 345,
            borderWidth: 1.5,
        },
        input: {
            fontSize: 16,
            margin: '0 0 0 10px',
        },
        prefix: {
            fontSize: 16,
            marginLeft: 20,
        },
        button: {
            fontSize: 16,
            width: 134,
            height: 46,
        },
    },
    [BCPhoneInputVariant.DRAWER_MOBILE]: {
        container: {
            maxWidth: 288,
        },
        inputContainer: {
            height: 49,
            minWidth: 288,
            borderWidth: 1.5,
            padding: '0 3px',
        },
        input: {
            fontSize: 14,
            margin: '0 0 0 7px',
        },
        prefix: {
            fontSize: 14,
            marginLeft: 7,
        },
        button: {
            fontSize: 14,
            width: 80,
            height: 40,
        },
    },
};
const InputContainer = styled(Grid, {
    shouldForwardProp: (prop) => !['variant'].includes(prop.toString()),
})(({ variant, theme }) => {
    const variantStyle = variantStyles[variant];
    return Object.assign(Object.assign({ width: '100%', position: 'relative' }, variantStyle.container), { '.textme_header': {
            fontWeight: 600,
            color: theme.vars.palette.text.primary,
            fontSize: 18,
            marginBottom: 10,
            [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
                display: 'none',
            },
        }, '.textme_input': Object.assign(Object.assign({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', borderStyle: 'solid', borderColor: theme.vars.palette.primary.main, borderRadius: 100, backgroundColor: '#fff', padding: '0 5px', maxWidth: 400, width: '100%', boxSizing: 'border-box' }, variantStyle.inputContainer), { '.text_prefix': Object.assign(Object.assign({ color: theme.vars.palette.text.primary, fontWeight: 500 }, variantStyle.prefix), { '&.sent': {
                    display: 'none',
                } }), input: Object.assign(Object.assign({ fontFamily: 'Poppins', width: 0, flex: 1, color: theme.vars.palette.text.primary, backgroundColor: '#fff', fontWeight: 500, border: 0, outline: 'none' }, variantStyle.input), { '&.sent': {
                    display: 'none',
                }, '&::placeholder': {
                    color: '#a7afc4',
                } }), '.text_button': Object.assign(Object.assign({ cursor: 'pointer', fontWeight: 500, marginRight: 0, border: 0, backgroundColor: theme.vars.palette.primary.main, color: theme.vars.palette.primary.contrastText, borderRadius: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s ease' }, variantStyle.button), { '&.sent': {
                    width: '100%',
                } }) }), '.textme_button_group': {
            display: 'none',
            [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
                display: 'flex',
                marginTop: 15,
                gap: '10px',
                button: {
                    borderWidth: 1,
                    borderStyle: 'solid',
                    outline: 'none',
                    borderRadius: 100,
                    height: 40,
                    fontSize: 16,
                    '&.download': {
                        borderColor: theme.vars.palette.primary.main,
                        color: theme.vars.palette.text.primary,
                        background: 'rgba(158,224,208,.2)',
                        flex: 1,
                    },
                    '&.text_link': {
                        flex: 1,
                        borderColor: theme.vars.palette.primary.main,
                        color: brandclub_colors.white,
                        background: theme.vars.palette.primary.main,
                    },
                },
            },
        } });
});
const ErrorMessage = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    if (!children) {
        return null;
    }
    const lineHeight = 1.5;
    return (React__default.createElement(Typography, Object.assign({}, props, { sx: (theme) => ({
            color: theme.vars.palette.error.main,
            backgroundColor: theme.vars.palette.error.light,
            fontSize: 14,
            marginTop: 2.5,
            padding: '7px 12px 7px 9px',
            display: 'flex',
            alignItems: 'flex-start',
            width: 'max-content',
            borderRadius: 1,
            fontWeight: 600,
            lineHeight,
        }) }),
        React__default.createElement(Box, { component: "span", display: "flex", alignItems: "center", height: `${lineHeight}em` },
            React__default.createElement(ErrorIcon, { sx: { paddingRight: 0.75, fontSize: 18 } })),
        children));
};
const getSendStatusMessage = (sendStatus, defaultMessage) => {
    switch (sendStatus) {
        case 'sending':
            return (React__default.createElement(React__default.Fragment, null,
                "Sending",
                React__default.createElement(ButtonLoadingEllipsis, { baseFontSize: 17 })));
        case 'sent':
            return 'Text sent!';
        default:
            return defaultMessage;
    }
};
const BrandclubPhoneInput = ({ handleSendText, qrCodeUrl, hasHeader = true, buttonText = 'Send Text', variant, onTextSent, userProfile, }) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [sendStatus, setSendStatus] = useState('normal');
    const desktopView = useMediaQuery(`(min-width:${TABLET_SCREEN_SIZE}px)`);
    const mobileView = useMediaQuery(`(max-width:${MOBILE_SCREEN_SIZE}px)`);
    const isSignedIn = !!userProfile;
    const userPhoneNumber = userProfile === null || userProfile === void 0 ? void 0 : userProfile.phoneNumber;
    const variantToUse = variant
        ? variant
        : desktopView
            ? BCPhoneInputVariant.DEFAULT
            : mobileView
                ? BCPhoneInputVariant.XS
                : BCPhoneInputVariant.SM;
    useEffect(() => {
        if (sendStatus === 'sent') {
            // Reset the send status after 3 seconds
            setTimeout(() => {
                setSendStatus('normal');
                setPhoneNumber('');
            }, 3000);
        }
    }, [sendStatus]);
    const sendText = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let number = userPhoneNumber !== null && userPhoneNumber !== void 0 ? userPhoneNumber : phoneNumber;
            number = number.replace(/\D/g, ''); // removes all non-digit characters
            setSendStatus('sending');
            const res = yield handleSendText(number);
            const sentStatus = _get(res, ['waitListEntry', 'textInvitationStatus']);
            if (sentStatus === 'sent') {
                if (onTextSent)
                    onTextSent();
                setSendStatus('sent');
            }
            else {
                setSendStatus('failed');
            }
        }
        catch (e) {
            setSendStatus('failed');
        }
    });
    return (React__default.createElement(Box, { display: "flex", flexDirection: "column" },
        qrCodeUrl && (React__default.createElement(QRCodeContainer, null,
            React__default.createElement(QRCode, { value: qrCodeUrl, fgColor: "#181d56", size: 95 }))),
        React__default.createElement(InputContainer, { container: true, flexDirection: 'column', variant: variantToUse },
            hasHeader && React__default.createElement("div", { className: "textme_header" }, "Download the app to access rewards"),
            isSignedIn && userPhoneNumber ? (React__default.createElement(Button, { sx: {
                    height: 50,
                    maxWidth: 355,
                    width: '100%',
                    fontSize: 16,
                    alignSelf: 'center',
                    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
                        height: 40,
                        fontSize: 12,
                        maxWidth: 300,
                    },
                }, onClick: ['normal', 'failed'].includes(sendStatus) ? sendText : undefined, disabled: sendStatus === 'sending' }, getSendStatusMessage(sendStatus, `Text link to ${formatPhoneNumber(userPhoneNumber)}`))) : (React__default.createElement("div", { className: `textme_input` },
                React__default.createElement("div", { className: `text_prefix ${sendStatus}` }, "+1"),
                React__default.createElement("input", { className: `phone_input ${sendStatus}`, name: "phone_number", placeholder: "Phone number", value: phoneNumber, type: "tel", onChange: (e) => {
                        setSendStatus('normal');
                        setPhoneNumber(e.target.value);
                    } }),
                React__default.createElement(Button, { className: `text_button ${sendStatus}`, style: {
                        minWidth: 'max-content',
                    }, onClick: ['normal', 'failed'].includes(sendStatus) ? sendText : undefined, disabled: sendStatus === 'sending' }, getSendStatusMessage(sendStatus, buttonText))))),
        React__default.createElement(ErrorMessage, null, sendStatus === 'failed' && 'Failed to send text. Please try again.')));
};

export { BCPhoneInputVariant, BrandclubPhoneInput as default };
//# sourceMappingURL=index.js.map
